import { Checkbox, FormControlLabel } from "@mui/material";
import type { FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { FormComponentProps } from "./FormComponentProps";

interface FormCheckboxProps<TFieldValues extends FieldValues = FieldValues> extends FormComponentProps<TFieldValues> {
  readonly size?: "small" | "medium";
}

function FormCheckbox<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  size,
  disabled,
}: FormCheckboxProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={<Checkbox checked={value} onChange={onChange} name={name} size={size} disabled={disabled} />}
          label={label}
          disabled={disabled}
          sx={size === "small" ? { "& .MuiFormControlLabel-label": { lineHeight: 1.2 } } : undefined}
        />
      )}
    />
  );
}

export default FormCheckbox;
